import { render } from "./DahuiyuanIntroduce.vue?vue&type=template&id=3f01df5e&scoped=true"
import script from "./DahuiyuanIntroduce.vue?vue&type=script&lang=js"
export * from "./DahuiyuanIntroduce.vue?vue&type=script&lang=js"

import "./DahuiyuanIntroduce.vue?vue&type=style&index=0&id=3f01df5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f01df5e"]])

export default __exports__